import { demoCampaigns, demoCategories, demoLedger as initialLedger } from './demoData.js'

const DEMO_APPS_KEY = 'plotfy_demo_applications_v2'
const DEMO_WALLET_KEY = 'plotfy_demo_brand_wallet_v1'
const DEMO_BANKS_KEY = 'plotfy_demo_bank_accounts_v1'

const initialAppsFormatted = [
  {
    id: '8401',
    publicId: '8401',
    creatorName: 'Nadia Putri',
    tiktokUsername: 'nadiabercerita',
    campaignId: 'mie-bang-jono',
    campaignTitle: 'Cerita Pedas Mie Bang Jono',
    brandName: 'Mie Bang Jono',
    category: 'F&B',
    location: 'Baubau, Sulawesi Tenggara',
    cover: '/images/campaign-food.svg',
    status: 'APPROVED',
    rateSnapshot: 15000,
    appliedAt: '2026-08-15T10:00:00Z',
    approvedAt: '2026-08-15T10:00:00Z',
    dueAt: '2026-08-25T10:00:00Z',
    campaign: demoCampaigns[0],
  },
  {
    id: 'APL-2048',
    publicId: 'APL-2048',
    creatorName: 'Nadia Putri',
    tiktokUsername: 'nadiabercerita',
    campaignId: 'mie-bang-jono',
    campaignTitle: 'Cerita Pedas Mie Bang Jono',
    brandName: 'Mie Bang Jono',
    category: 'F&B',
    location: 'Baubau, Sulawesi Tenggara',
    cover: '/images/campaign-food.svg',
    status: 'IN_PROGRESS',
    rateSnapshot: 15000,
    appliedAt: '2026-08-12T08:00:00Z',
    dueAt: '2026-08-24T08:00:00Z',
    campaign: demoCampaigns[0],
  },
  {
    id: 'APL-1984',
    publicId: 'APL-1984',
    creatorName: 'Arfan Malik',
    tiktokUsername: 'arfaneats',
    campaignId: 'lume-skin-barrier',
    campaignTitle: '7 Hari Skin Barrier Journal',
    brandName: 'Lumé Studio',
    category: 'Beauty',
    location: 'Makassar, Sulawesi Selatan',
    cover: '/images/campaign-beauty.svg',
    status: 'SUBMITTED',
    rateSnapshot: 22000,
    appliedAt: '2026-08-08T08:00:00Z',
    submissionUrl: 'https://www.tiktok.com/@arfaneats/video/1234567890123456789',
    submittedAt: '2026-08-14T09:00:00Z',
    campaign: demoCampaigns[1],
  },
  {
    id: 'APL-1832',
    publicId: 'APL-1832',
    creatorName: 'Salsa Anjani',
    tiktokUsername: 'salsadaily',
    campaignId: 'nala-coffee-morning',
    campaignTitle: 'Morning Ritual di Nala',
    brandName: 'Nala Coffee',
    category: 'F&B',
    location: 'Yogyakarta',
    cover: '/images/campaign-coffee.svg',
    status: 'VALIDATED',
    rateSnapshot: 20000,
    appliedAt: '2026-07-28T08:00:00Z',
    submissionUrl: 'https://www.tiktok.com/@salsadaily/video/9876543210987654321',
    submittedAt: '2026-08-01T08:00:00Z',
    validViews: 12500,
    earningAmount: 250000,
    campaign: demoCampaigns[4],
  },
]

const initialBankAccounts = [
  { id: '1', bankName: 'Bank BCA', accountName: 'PT Plotfy Media Indonesia', accountNumber: '8830-1234-5678', isActive: true, sortOrder: 10 },
  { id: '2', bankName: 'Bank Mandiri', accountName: 'PT Plotfy Media Indonesia', accountNumber: '137-00-9876-5432', isActive: true, sortOrder: 20 },
  { id: '3', bankName: 'Bank BRI', accountName: 'PT Plotfy Media Indonesia', accountNumber: '0021-01-001234-56-7', isActive: true, sortOrder: 30 },
]

const initialBrandWallet = {
  balanceAmount: '2000000.00',
  frozenAmount: '0.00',
  isFrozen: false,
  autoFreezeThreshold: '500000.00',
  freezeReason: null,
}

export function getDemoApplications() {
  try {
    const raw = sessionStorage.getItem(DEMO_APPS_KEY)
    if (raw) return JSON.parse(raw)
  } catch {}
  return initialAppsFormatted
}

export function saveDemoApplications(apps) {
  try {
    sessionStorage.setItem(DEMO_APPS_KEY, JSON.stringify(apps))
  } catch {}
  window.dispatchEvent(new CustomEvent('plotfy:demo-apps-changed'))
}

export function updateDemoApplicationStatus(id, newStatus, extra = {}) {
  const apps = getDemoApplications()
  const idx = apps.findIndex((a) => a.id === id || a.publicId === id)
  if (idx !== -1) {
    apps[idx] = {
      ...apps[idx],
      status: newStatus,
      ...extra,
      ...(newStatus === 'APPROVED' || newStatus === 'IN_PROGRESS' ? { approvedAt: new Date().toISOString() } : {}),
    }
    saveDemoApplications(apps)
    return apps[idx]
  }
  return null
}

export function applyDemoCampaign(campaign, user, effectiveRate) {
  const apps = getDemoApplications()
  const newApp = {
    id: `APL-${Date.now().toString().slice(-4)}`,
    publicId: `APL-${Date.now().toString().slice(-4)}`,
    creatorName: user?.name || user?.displayName || 'Creator Demo',
    tiktokUsername: user?.creatorProfile?.tiktokUsername || 'creatordemo',
    campaignId: campaign.id || campaign.publicId,
    campaignTitle: campaign.title,
    brandName: campaign.brandName || campaign.brand?.name || 'Brand',
    category: campaign.categoryName || campaign.category?.name || 'Umum',
    location: campaign.location || 'Indonesia',
    cover: campaign.cover || '/images/campaign-lifestyle.svg',
    status: 'APPROVED',
    rateSnapshot: effectiveRate || campaign.rate || 15000,
    appliedAt: new Date().toISOString(),
    approvedAt: new Date().toISOString(),
    dueAt: campaign.endAt || new Date(Date.now() + 7 * 86400000).toISOString(),
    campaign,
  }
  apps.unshift(newApp)
  saveDemoApplications(apps)
  return newApp
}

export function submitDemoContent(id, tiktokUrl, note) {
  return updateDemoApplicationStatus(id, 'SUBMITTED', {
    submissionUrl: tiktokUrl,
    submissionNote: note,
    submittedAt: new Date().toISOString(),
  })
}

export function validateDemoViews(id, validViews, note) {
  const apps = getDemoApplications()
  const idx = apps.findIndex((a) => a.id === id || a.publicId === id)
  if (idx !== -1) {
    const rate = Number(apps[idx].rateSnapshot || 15000)
    const theoreticalEarning = Math.floor((Number(validViews) * rate) / 1000)

    // Calculate remaining campaign budget
    const campaignId = apps[idx].campaignId || apps[idx].campaign?.id
    const campaigns = getDemoCampaigns()
    const campaign = campaigns.find((c) => c.id === campaignId || c.publicId === campaignId)
    let maxBudget = theoreticalEarning
    if (campaign) {
      const budgetTotal = Number(campaign.budgetTotal || campaign.budget_total || 0)
      const otherApps = apps.filter((a) => (a.campaignId === campaignId || a.campaign?.id === campaignId) && a.id !== apps[idx].id && a.status === 'VALIDATED')
      const spentByOthers = otherApps.reduce((sum, a) => sum + (Number(a.earningAmount) || 0), 0)
      const remaining = Math.max(0, budgetTotal - spentByOthers)
      maxBudget = remaining
    }
    const earningAmount = Math.min(theoreticalEarning, maxBudget)

    apps[idx] = {
      ...apps[idx],
      status: 'VALIDATED',
      validViews: Number(validViews),
      earningAmount,
      validationNote: note,
      validatedAt: new Date().toISOString(),
    }
    saveDemoApplications(apps)

    // Automatically check if the campaign is expired and all creators are completed -> refund leftover!
    try {
      const campaignId = apps[idx].campaignId || apps[idx].campaign?.id
      const campaigns = getDemoCampaigns()
      const campaign = campaigns.find((c) => c.id === campaignId || c.publicId === campaignId)

      const campaignApps = apps.filter(
        (a) => (a.campaignId === campaignId || a.campaign?.id === campaignId) && !['CANCELLED', 'REJECTED'].includes(a.status)
      )
      const hasPending = campaignApps.some((a) =>
        ['PENDING', 'APPROVED', 'IN_PROGRESS', 'SUBMITTED', 'UNDER_REVIEW', 'REVISION_REQUIRED'].includes(a.status)
      )

      if (!hasPending && campaign) {
        const totalSpent = campaignApps.reduce((sum, a) => sum + (Number(a.earningAmount) || 0), 0)
        const budgetTotal = Number(campaign.budgetTotal || campaign.budget_total || 0)
        const unspent = Math.max(0, budgetTotal - totalSpent)

        if (unspent > 0) {
          creditDemoBrandWallet(unspent)
          recordDemoBrandTransaction({
            brandId: '1',
            brandName: 'Nala Coffee',
            ownerEmail: 'brand@plotfy.id',
            campaignId: String(campaign.id || '4'),
            campaignTitle: campaign.title || 'Campaign',
            campaignPublicId: campaign.publicId || String(campaign.id),
            transactionType: 'CAMPAIGN_EXPIRED_REFUND',
            direction: 'CREDIT',
            amount: String(unspent.toFixed(2)),
            description: `Refund sisa saldo campaign expired “${campaign.title || 'Campaign'}”`,
            metadata: {
              campaignId: String(campaign.id),
              campaignTitle: campaign.title,
              budgetTotal: String(budgetTotal),
              budgetSpent: String(totalSpent),
              refundAmount: String(unspent.toFixed(2)),
            },
          })

          const refunds = getDemoExpiredCampaignRefunds()
          const rIdx = refunds.findIndex((r) => r.id === String(campaign.id) || r.publicId === campaign.publicId)
          if (rIdx !== -1) {
            refunds[rIdx] = {
              ...refunds[rIdx],
              isPendingCreators: false,
              isRefunded: true,
              refundAmount: String(unspent.toFixed(2)),
              refundedAt: new Date().toISOString(),
              refundDescription: `Refund sisa saldo campaign expired “${campaign.title}”`,
            }
            saveDemoExpiredCampaignRefunds(refunds)
          }
        }
      }
    } catch (_e) {
      console.warn('Demo validation refund hook error:', _e)
    }

    return apps[idx]
  }
  return null
}

export function findDemoApplication(id) {
  const apps = getDemoApplications()
  return apps.find((a) => a.id === id || a.publicId === id) || apps[0]
}

// Demo Brand Wallet & Platform Bank Accounts
export function getDemoBrandWallet() {
  try {
    const raw = localStorage.getItem(DEMO_WALLET_KEY) || sessionStorage.getItem(DEMO_WALLET_KEY)
    if (raw) return JSON.parse(raw)
  } catch {}
  return initialBrandWallet
}

export function saveDemoBrandWallet(wallet) {
  try {
    localStorage.setItem(DEMO_WALLET_KEY, JSON.stringify(wallet))
    sessionStorage.setItem(DEMO_WALLET_KEY, JSON.stringify(wallet))
  } catch {}
  window.dispatchEvent(new CustomEvent('plotfy:demo-wallet-changed'))
}

export function creditDemoBrandWallet(amount) {
  const current = getDemoBrandWallet()
  const nextBalance = (Number(current.balanceAmount) + Number(amount)).toFixed(2)
  const threshold = Number(current.autoFreezeThreshold)
  const nextFrozen = Number(nextBalance) <= threshold ? current.isFrozen : false
  const updated = {
    ...current,
    balanceAmount: nextBalance,
    isFrozen: nextFrozen,
    freezeReason: nextFrozen ? current.freezeReason : null,
  }
  saveDemoBrandWallet(updated)
  return updated
}

export function deductDemoBrandWallet(amount) {
  const current = getDemoBrandWallet()
  const nextBalance = Math.max(0, Number(current.balanceAmount) - Number(amount)).toFixed(2)
  const threshold = Number(current.autoFreezeThreshold)
  const autoFreeze = Number(nextBalance) <= threshold
  const updated = {
    ...current,
    balanceAmount: nextBalance,
    isFrozen: current.isFrozen || autoFreeze,
    freezeReason: autoFreeze ? 'Batas saldo minimal tercapai (Auto-Freeze)' : current.freezeReason,
  }
  saveDemoBrandWallet(updated)
  return updated
}

export function toggleFreezeDemoBrandWallet(isFrozen, freezeReason, autoFreezeThreshold) {
  const current = getDemoBrandWallet()
  const updated = {
    ...current,
    isFrozen: isFrozen !== undefined ? isFrozen : current.isFrozen,
    freezeReason: freezeReason ?? current.freezeReason,
    autoFreezeThreshold: autoFreezeThreshold ? String(autoFreezeThreshold) : current.autoFreezeThreshold,
  }
  saveDemoBrandWallet(updated)
  return updated
}

export function setDemoBrandWalletThreshold(threshold) {
  const current = getDemoBrandWallet()
  const threshNum = Number(threshold)
  const isBelow = Number(current.balanceAmount) <= threshNum
  const updated = {
    ...current,
    autoFreezeThreshold: String(threshNum.toFixed(2)),
    isFrozen: isBelow ? true : false,
    freezeReason: isBelow ? 'Batas saldo minimal tercapai (Harap Top Up)' : null,
  }
  saveDemoBrandWallet(updated)
  return updated
}

export function getDemoBankAccounts() {
  try {
    const raw = sessionStorage.getItem(DEMO_BANKS_KEY)
    if (raw) return JSON.parse(raw)
  } catch {}
  return initialBankAccounts
}

export function saveDemoBankAccounts(accounts) {
  try {
    sessionStorage.setItem(DEMO_BANKS_KEY, JSON.stringify(accounts))
  } catch {}
  window.dispatchEvent(new CustomEvent('plotfy:demo-banks-changed'))
}

const DEMO_TOPUP_REQUESTS_KEY = 'plotfy_demo_topup_requests'
const initialTopUpRequests = [
  {
    id: 'req-101',
    brandId: '1',
    brandName: 'Nala Coffee',
    ownerEmail: 'brand@plotfy.id',
    bankName: 'Bank BCA',
    accountNumber: '8830-1234-5678',
    amount: '2000000',
    status: 'PENDING',
    proofNotes: 'Menunggu screenshot bukti transfer via WA',
    createdAt: new Date(Date.now() - 1000 * 60 * 30).toISOString(),
  },
  {
    id: 'req-100',
    brandId: '1',
    brandName: 'Nala Coffee',
    ownerEmail: 'brand@plotfy.id',
    bankName: 'Bank BCA',
    accountNumber: '8830-1234-5678',
    amount: '5000000',
    status: 'APPROVED',
    proofNotes: 'Screenshot bukti transfer terverifikasi via WA Admin',
    adminNote: 'Top-Up Rp 5.000.000 divalidasi & masuk ke saldo brand',
    processedAt: new Date(Date.now() - 1000 * 60 * 60 * 24).toISOString(),
    validatedBy: 'Admin Plotfy',
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 25).toISOString(),
  },
  {
    id: 'req-099',
    brandId: '1',
    brandName: 'Nala Coffee',
    ownerEmail: 'brand@plotfy.id',
    bankName: 'Bank Mandiri',
    accountNumber: '1370-0099-8877',
    amount: '1000000',
    status: 'REJECTED',
    proofNotes: 'Bukti transfer tidak valid / mutasi rekening tidak ditemukan',
    adminNote: 'Ditolak: Transfer tidak ditemukan di mutasi rekening bank tujuan.',
    processedAt: new Date(Date.now() - 1000 * 60 * 60 * 48).toISOString(),
    validatedBy: 'Admin Plotfy',
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 50).toISOString(),
  },
]

export function getDemoTopUpRequests() {
  try {
    const raw = localStorage.getItem(DEMO_TOPUP_REQUESTS_KEY) || sessionStorage.getItem(DEMO_TOPUP_REQUESTS_KEY)
    if (raw) return JSON.parse(raw)
  } catch {}
  return initialTopUpRequests
}

export function saveDemoTopUpRequests(requests) {
  try {
    localStorage.setItem(DEMO_TOPUP_REQUESTS_KEY, JSON.stringify(requests))
    sessionStorage.setItem(DEMO_TOPUP_REQUESTS_KEY, JSON.stringify(requests))
  } catch {}
  window.dispatchEvent(new CustomEvent('plotfy:demo-topup-changed'))
}

export function addDemoTopUpRequest({ id, brandName = 'Nala Coffee', bankName, accountNumber, amount, proofNotes }) {
  const current = getDemoTopUpRequests()
  const reqId = id ? String(id) : ('req-' + Date.now())
  const newReq = {
    id: reqId,
    brandId: '1',
    brandName: brandName || 'Nala Coffee',
    ownerEmail: 'brand@plotfy.id',
    bankName: bankName || 'Bank BCA',
    accountNumber: accountNumber || '8830-1234-5678',
    amount: String(amount),
    status: 'PENDING',
    proofNotes: proofNotes || 'Pengajuan via web, screenshot dikirim ke WA Admin',
    createdAt: new Date().toISOString(),
  }
  const filtered = current.filter(r => String(r.id) !== reqId)
  const updated = [newReq, ...filtered]
  saveDemoTopUpRequests(updated)
  return newReq
}

export function approveDemoTopUpRequest(id, amount, note) {
  const current = getDemoTopUpRequests()
  const target = current.find(r => String(r.id) === String(id))
  if (target) {
    target.status = 'APPROVED'
    target.processedAt = new Date().toISOString()
    target.adminNote = note || 'Divalidasi oleh Admin Plotfy (Transfer terverifikasi)'
    target.validatedBy = 'Admin Plotfy'
    saveDemoTopUpRequests([...current])
    creditDemoBrandWallet(target.amount)
  } else if (amount) {
    creditDemoBrandWallet(amount)
  }
  return target
}

export function rejectDemoTopUpRequest(id, note) {
  const current = getDemoTopUpRequests()
  const target = current.find(r => String(r.id) === String(id))
  if (target) {
    target.status = 'REJECTED'
    target.processedAt = new Date().toISOString()
    target.adminNote = note || 'Ditolak: Bukti transfer tidak valid atau dana tidak masuk'
    target.validatedBy = 'Admin Plotfy'
    saveDemoTopUpRequests([...current])
  }
  return target
}

const DEMO_USERS_KEY = 'plotfy_demo_users_v1'
const DEMO_CREATORS_KEY = 'plotfy_demo_creators_v1'
const DEMO_BRANDS_KEY = 'plotfy_demo_brands_v1'

const initialDemoUsers = [
  { id: 'usr-1', name: 'Nadia Putri', email: 'nadia@example.com', city: 'Makassar', status: 'ACTIVE', role: 'CREATOR', createdAt: '2026-07-21' },
  { id: 'usr-2', name: 'Nala Coffee', email: 'brand@nala.id', city: 'Yogyakarta', status: 'VERIFIED', role: 'BRAND', createdAt: '2026-06-11' },
  { id: 'usr-3', name: 'Arfan Malik', email: 'arfan@example.com', city: 'Yogyakarta', status: 'ACTIVE', role: 'CREATOR', createdAt: '2026-07-29' },
]

const initialDemoCreators = [
  {
    id: 'crt-1',
    name: 'Nadia Putri',
    email: 'nadia@example.com',
    whatsapp: '0882019969674',
    instagramHandle: 'nadiabercerita',
    tiktokUsername: 'nadiahptrr',
    city: 'Kota Makassar',
    tier: 'SILVER',
    status: 'ACTIVE',
    createdAt: '2026-07-21',
    category: 'Fashion',
    followersInstagram: 2013,
    followersTiktok: 223,
  },
  {
    id: 'crt-2',
    name: 'Arfan Malik',
    email: 'arfan@example.com',
    whatsapp: '081370000918',
    instagramHandle: 'arfaneats',
    tiktokUsername: 'arfanmalik',
    city: 'Kota Makassar',
    tier: 'GOLD',
    status: 'ACTIVE',
    createdAt: '2026-07-29',
    category: 'F&B',
    followersInstagram: 10200,
    followersTiktok: 5744,
  },
]

const initialDemoBrands = [
  { id: 'brd-1', name: 'Nala Coffee', email: 'brand@nala.id', city: 'Yogyakarta', status: 'VERIFIED', createdAt: '2026-06-11' },
  { id: 'brd-2', name: 'Lumé Studio', email: 'hello@lume.id', city: 'Makassar', status: 'PENDING', createdAt: '2026-08-02' },
]

export function getDemoResourceList(resource) {
  const key = resource === 'users' ? DEMO_USERS_KEY : resource === 'creators' ? DEMO_CREATORS_KEY : DEMO_BRANDS_KEY
  const initial = resource === 'users' ? initialDemoUsers : resource === 'creators' ? initialDemoCreators : initialDemoBrands
  try {
    const raw = localStorage.getItem(key)
    return raw ? JSON.parse(raw) : initial
  } catch {
    return initial
  }
}

export function saveDemoResourceList(resource, items) {
  const key = resource === 'users' ? DEMO_USERS_KEY : resource === 'creators' ? DEMO_CREATORS_KEY : DEMO_BRANDS_KEY
  try {
    localStorage.setItem(key, JSON.stringify(items))
  } catch (err) {
    console.error(err)
  }
}

export function updateDemoResourceStatus(resource, id, status) {
  const items = getDemoResourceList(resource)
  const next = items.map((item) => (String(item.id) === String(id) ? { ...item, status } : item))
  saveDemoResourceList(resource, next)
  return next
}

export function deleteDemoResourceItem(resource, id) {
  const items = getDemoResourceList(resource)
  const next = items.filter((item) => String(item.id) !== String(id))
  saveDemoResourceList(resource, next)
  return next
}

const DEMO_ADMINS_KEY = 'plotfy_demo_admins_v1'

const initialDemoAdmins = [
  {
    id: 'adm-1',
    publicId: 'adm-super-1',
    username: 'superadmin',
    displayName: 'Super Admin Plotfy',
    email: 'superadmin@demo.plotfy.id',
    role: 'SUPERADMIN',
    adminAssignment: 'SUPERADMIN',
    status: 'ACTIVE',
    createdAt: '2026-06-01T00:00:00Z',
    lastLoginAt: '2026-08-19T08:00:00Z',
  },
  {
    id: 'adm-2',
    publicId: 'adm-brand-1',
    username: 'admin.brand',
    displayName: 'Admin Brand Operasional',
    email: 'brand.admin@demo.plotfy.id',
    role: 'ADMIN',
    adminAssignment: 'BRAND',
    status: 'ACTIVE',
    createdAt: '2026-07-01T00:00:00Z',
    lastLoginAt: '2026-08-18T14:30:00Z',
  },
  {
    id: 'adm-3',
    publicId: 'adm-creator-1',
    username: 'admin.creator',
    displayName: 'Admin Creator Validasi',
    email: 'creator.admin@demo.plotfy.id',
    role: 'ADMIN',
    adminAssignment: 'CREATOR',
    status: 'ACTIVE',
    createdAt: '2026-07-15T00:00:00Z',
    lastLoginAt: '2026-08-18T16:00:00Z',
  },
]

export function getDemoAdmins() {
  try {
    const raw = localStorage.getItem(DEMO_ADMINS_KEY)
    return raw ? JSON.parse(raw) : initialDemoAdmins
  } catch {
    return initialDemoAdmins
  }
}

export function saveDemoAdmins(admins) {
  try {
    localStorage.setItem(DEMO_ADMINS_KEY, JSON.stringify(admins))
  } catch (err) {
    console.error(err)
  }
  window.dispatchEvent(new CustomEvent('plotfy:demo-admins-changed'))
}

export function createDemoAdmin(input) {
  const current = getDemoAdmins()
  const newAdmin = {
    id: `adm-${Date.now()}`,
    publicId: `adm-${Math.random().toString(36).slice(2, 10)}`,
    username: input.username,
    displayName: input.displayName,
    email: input.email,
    role: input.role || 'ADMIN',
    adminAssignment: input.adminAssignment || 'ALL',
    status: 'ACTIVE',
    createdAt: new Date().toISOString(),
    lastLoginAt: null,
  }
  saveDemoAdmins([newAdmin, ...current])
  return newAdmin
}

export function updateDemoAdminStatus(publicId, status) {
  const current = getDemoAdmins()
  const next = current.map((adm) => (adm.publicId === publicId ? { ...adm, status } : adm))
  saveDemoAdmins(next)
  return next
}

export function deleteDemoAdmin(publicId) {
  const current = getDemoAdmins()
  const next = current.filter((adm) => adm.publicId !== publicId)
  saveDemoAdmins(next)
  return next
}

const DEMO_SETTINGS_KEY = 'plotfy:demo-platform-settings'
const DEFAULT_DEMO_SETTINGS = {
  adminWhatsappNumber: '081234567890',
  contactEmail: 'halo@plotfy.id',
  instagramHandle: 'Instagram',
  instagramUrl: 'https://instagram.com',
  termsUrl: 'https://plotfy.id/terms',
  minBudgets: {
    SILVER: 500000,
    GOLD: 1500000,
    PLATINUM: 3000000,
    DIAMOND: 5000000,
  },
  defaultRates: {
    SILVER: 1500,
    GOLD: 2200,
    PLATINUM: 3000,
    DIAMOND: 4000,
  },
  tierSettings: {
    SILVER: { minBudget: '500000.00', defaultRate: '1500.00' },
    GOLD: { minBudget: '1500000.00', defaultRate: '2200.00' },
    PLATINUM: { minBudget: '3000000.00', defaultRate: '3000.00' },
    DIAMOND: { minBudget: '5000000.00', defaultRate: '4000.00' },
  },
  topupFee: {
    enabled: false,
    type: 'FIXED',
    value: 0,
  },
  withdrawalFee: {
    enabled: false,
    type: 'FIXED',
    value: 0,
  },
  minWithdrawalAmount: 50000,
  logoUrl: null,
}

export function getDemoSettings() {
  try {
    const raw = localStorage.getItem(DEMO_SETTINGS_KEY)
    if (raw) return { ...DEFAULT_DEMO_SETTINGS, ...JSON.parse(raw) }
  } catch (err) {
    console.error(err)
  }
  return DEFAULT_DEMO_SETTINGS
}

export function saveDemoSettings(settings, { emit = true } = {}) {
  try {
    localStorage.setItem(DEMO_SETTINGS_KEY, JSON.stringify(settings))
  } catch (err) {
    console.error(err)
  }
  if (emit && typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('plotfy:demo-settings-changed', { detail: settings }))
  }
}

export function getAdminWhatsappNumber() {
  return getDemoSettings().adminWhatsappNumber || '081234567890'
}

export function setAdminWhatsappNumber(num) {
  const current = getDemoSettings()
  current.adminWhatsappNumber = String(num || '')
  saveDemoSettings(current)
  return current.adminWhatsappNumber
}

export function getFormattedWhatsappNumber(input) {
  let cleaned = String(input || getAdminWhatsappNumber() || '').replace(/\D/g, '')
  if (cleaned.startsWith('0')) {
    cleaned = '62' + cleaned.slice(1)
  } else if (cleaned.startsWith('8')) {
    cleaned = '62' + cleaned
  }
  return cleaned || '6281234567890'
}

export function getTierSettings() {
  const s = getDemoSettings()
  return s.tierSettings || DEFAULT_DEMO_SETTINGS.tierSettings
}

export function getTierMinBudgets() {
  const s = getDemoSettings()
  return s.minBudgets || DEFAULT_DEMO_SETTINGS.minBudgets
}

export function getTierDefaultRates() {
  const s = getDemoSettings()
  const ts = s.tierSettings || DEFAULT_DEMO_SETTINGS.tierSettings
  return {
    SILVER: String(Number(ts.SILVER?.defaultRate ?? s.defaultRates?.SILVER ?? 1500)),
    GOLD: String(Number(ts.GOLD?.defaultRate ?? s.defaultRates?.GOLD ?? 2200)),
    PLATINUM: String(Number(ts.PLATINUM?.defaultRate ?? s.defaultRates?.PLATINUM ?? 3000)),
    DIAMOND: String(Number(ts.DIAMOND?.defaultRate ?? s.defaultRates?.DIAMOND ?? 4000)),
  }
}

export function cleanNumericValue(input) {
  if (input === undefined || input === null || input === '') return 0
  let str = String(input).trim()

  if (str.includes('.') && str.includes(',')) {
    if (str.lastIndexOf(',') > str.lastIndexOf('.')) {
      str = str.replace(/\./g, '').replace(/,/g, '.')
    } else {
      str = str.replace(/,/g, '')
    }
  } else if (str.includes(',')) {
    if (/,\d{3}$/.test(str)) {
      str = str.replace(/,/g, '')
    } else {
      str = str.replace(/,/g, '.')
    }
  } else if (str.includes('.')) {
    if (/\.\d{3}(\.|$)/.test(str)) {
      str = str.replace(/\./g, '')
    }
  }

  str = str.replace(/[^0-9.]/g, '')
  const parts = str.split('.')
  if (parts.length > 2) {
    str = parts[0] + '.' + parts.slice(1).join('')
  }
  const num = Number(str)
  return Number.isNaN(num) ? 0 : num
}

export function getMinWithdrawalSetting() {
  const s = getDemoSettings()
  return cleanNumericValue(s.minWithdrawalAmount ?? 50000) || 50000
}

export function setMinWithdrawalSetting(val) {
  const current = getDemoSettings()
  current.minWithdrawalAmount = cleanNumericValue(val) || 50000
  saveDemoSettings(current)
  return current.minWithdrawalAmount
}

export function getFeeSettings() {
  const s = getDemoSettings()
  const tf = s.topupFee || DEFAULT_DEMO_SETTINGS.topupFee
  const wf = s.withdrawalFee || DEFAULT_DEMO_SETTINGS.withdrawalFee
  return {
    topupFee: {
      enabled: tf.enabled === true || String(tf.enabled) === 'true',
      type: String(tf.type || 'FIXED').trim().toUpperCase() === 'PERCENT' ? 'PERCENT' : 'FIXED',
      value: cleanNumericValue(tf.value),
    },
    withdrawalFee: {
      enabled: wf.enabled === true || String(wf.enabled) === 'true',
      type: String(wf.type || 'FIXED').trim().toUpperCase() === 'PERCENT' ? 'PERCENT' : 'FIXED',
      value: cleanNumericValue(wf.value),
    },
  }
}

export function setFeeSettings(updates = {}) {
  const current = getDemoSettings()
  const currentTf = current.topupFee || DEFAULT_DEMO_SETTINGS.topupFee
  const currentWf = current.withdrawalFee || DEFAULT_DEMO_SETTINGS.withdrawalFee

  const nextTf = updates.topupFee
    ? { ...currentTf, ...updates.topupFee }
    : updates.topupFeeEnabled !== undefined
    ? {
        enabled: updates.topupFeeEnabled === true || String(updates.topupFeeEnabled) === 'true',
        type: updates.topupFeeType ?? currentTf.type,
        value: cleanNumericValue(updates.topupFeeValue ?? currentTf.value),
      }
    : currentTf

  const nextWf = updates.withdrawalFee
    ? { ...currentWf, ...updates.withdrawalFee }
    : updates.withdrawalFeeEnabled !== undefined
    ? {
        enabled: updates.withdrawalFeeEnabled === true || String(updates.withdrawalFeeEnabled) === 'true',
        type: updates.withdrawalFeeType ?? currentWf.type,
        value: cleanNumericValue(updates.withdrawalFeeValue ?? currentWf.value),
      }
    : currentWf

  current.topupFee = {
    enabled: nextTf.enabled === true || String(nextTf.enabled) === 'true',
    type: String(nextTf.type || 'FIXED').trim().toUpperCase() === 'PERCENT' ? 'PERCENT' : 'FIXED',
    value: cleanNumericValue(nextTf.value),
  }
  current.withdrawalFee = {
    enabled: nextWf.enabled === true || String(nextWf.enabled) === 'true',
    type: String(nextWf.type || 'FIXED').trim().toUpperCase() === 'PERCENT' ? 'PERCENT' : 'FIXED',
    value: cleanNumericValue(nextWf.value),
  }

  saveDemoSettings(current)
  return current
}

export function setTierSettings(updates) {
  const current = getDemoSettings()
  current.tierSettings = {
    ...current.tierSettings,
    ...updates,
  }
  current.minBudgets = {
    SILVER: Number(current.tierSettings.SILVER?.minBudget || 500000),
    GOLD: Number(current.tierSettings.GOLD?.minBudget || 1500000),
    PLATINUM: Number(current.tierSettings.PLATINUM?.minBudget || 3000000),
    DIAMOND: Number(current.tierSettings.DIAMOND?.minBudget || 5000000),
  }
  current.defaultRates = {
    SILVER: Number(current.tierSettings.SILVER?.defaultRate || 1500),
    GOLD: Number(current.tierSettings.GOLD?.defaultRate || 2200),
    PLATINUM: Number(current.tierSettings.PLATINUM?.defaultRate || 3000),
    DIAMOND: Number(current.tierSettings.DIAMOND?.defaultRate || 4000),
  }
  saveDemoSettings(current)
  return current
}

const DEMO_TRANSACTIONS_KEY = 'plotfy_demo_brand_transactions_v1'

const initialDemoTransactions = [
  {
    id: 'tx-101',
    brandId: '1',
    brandName: 'Nala Coffee',
    ownerEmail: 'brand@plotfy.id',
    campaignId: '4',
    campaignTitle: 'Morning Ritual di Nala',
    campaignPublicId: 'nala-coffee-morning',
    transactionType: 'CAMPAIGN_EXPIRED_REFUND',
    direction: 'CREDIT',
    amount: '1600000.00',
    balanceBefore: '400000.00',
    balanceAfter: '2000000.00',
    description: 'Refund sisa saldo campaign expired “Morning Ritual di Nala”',
    createdAt: '2026-08-18T14:30:00Z',
  },
  {
    id: 'tx-102',
    brandId: '1',
    brandName: 'Nala Coffee',
    ownerEmail: 'brand@plotfy.id',
    campaignId: null,
    campaignTitle: null,
    campaignPublicId: null,
    transactionType: 'TOPUP',
    direction: 'CREDIT',
    amount: '5000000.00',
    balanceBefore: '1000000.00',
    balanceAfter: '6000000.00',
    description: 'Top Up Saldo via Transfer Bank BCA (Divalidasi Admin)',
    createdAt: '2026-08-10T09:15:00Z',
  },
  {
    id: 'tx-103',
    brandId: '1',
    brandName: 'Nala Coffee',
    ownerEmail: 'brand@plotfy.id',
    campaignId: '1',
    campaignTitle: 'Morning Ritual di Nala (Batch 2)',
    campaignPublicId: 'nala-coffee-morning-2',
    transactionType: 'CAMPAIGN_BUDGET_ALLOCATION',
    direction: 'DEBIT',
    amount: '5600000.00',
    balanceBefore: '6000000.00',
    balanceAfter: '400000.00',
    description: 'Alokasi budget untuk campaign baru “Morning Ritual di Nala (Batch 2)”',
    createdAt: '2026-08-11T10:00:00Z',
  },
]

export function getDemoBrandTransactions() {
  try {
    const raw = localStorage.getItem(DEMO_TRANSACTIONS_KEY) || sessionStorage.getItem(DEMO_TRANSACTIONS_KEY)
    if (raw) return JSON.parse(raw)
  } catch {}
  return initialDemoTransactions
}

export function saveDemoBrandTransactions(transactions) {
  try {
    localStorage.setItem(DEMO_TRANSACTIONS_KEY, JSON.stringify(transactions))
    sessionStorage.setItem(DEMO_TRANSACTIONS_KEY, JSON.stringify(transactions))
  } catch {}
  window.dispatchEvent(new CustomEvent('plotfy:demo-transactions-changed'))
  window.dispatchEvent(new CustomEvent('plotfy:demo-wallet-changed'))
}

export function recordDemoBrandTransaction(tx) {
  const currentTxs = getDemoBrandTransactions()
  const wallet = getDemoBrandWallet()
  const currentBal = Number(wallet.balanceAmount || 0)
  const isCredit = (tx.direction || 'CREDIT').toUpperCase() === 'CREDIT'
  const amountNum = Number(tx.amount || 0)

  const balanceBefore = tx.balanceBefore !== undefined ? String(Number(tx.balanceBefore).toFixed(2)) : String(currentBal.toFixed(2))
  const balanceAfter = tx.balanceAfter !== undefined ? String(Number(tx.balanceAfter).toFixed(2)) : String((isCredit ? currentBal + amountNum : Math.max(0, currentBal - amountNum)).toFixed(2))

  const newTx = {
    id: `tx-${Date.now()}-${Math.floor(Math.random() * 1000)}`,
    brandId: tx.brandId || '1',
    brandName: tx.brandName || 'Nala Coffee',
    ownerEmail: tx.ownerEmail || 'brand@plotfy.id',
    campaignId: tx.campaignId || null,
    campaignTitle: tx.campaignTitle || null,
    campaignPublicId: tx.campaignPublicId || null,
    transactionType: tx.transactionType || 'ADMIN_ADJUSTMENT',
    direction: isCredit ? 'CREDIT' : 'DEBIT',
    amount: String(amountNum.toFixed(2)),
    balanceBefore,
    balanceAfter,
    description: tx.description || 'Transaksi Saldo Dompet',
    metadata: tx.metadata || {},
    createdAt: new Date().toISOString(),
  }

  const updated = [newTx, ...currentTxs]
  saveDemoBrandTransactions(updated)
  return newTx
}

const DEMO_EXPIRED_REFUNDS_KEY = 'plotfy_demo_expired_refunds_v1'

const initialExpiredRefunds = [
  {
    id: '4',
    publicId: 'nala-coffee-morning',
    title: 'Morning Ritual di Nala',
    campaignStatus: 'COMPLETED',
    brandId: '1',
    brandName: 'Nala Coffee',
    ownerEmail: 'brand@plotfy.id',
    endAt: '2026-08-18T00:00:00Z',
    budgetTotal: '8000000.00',
    budgetSpent: '6400000.00',
    unspentLeftover: '1600000.00',
    pendingSubmissionCount: 0,
    pendingValidationCount: 0,
    completedCount: 2,
    totalCreatorCount: 2,
    isPendingCreators: false,
    isRefunded: true,
    refundAmount: '1600000.00',
    refundedAt: '2026-08-18T14:30:00Z',
    refundDescription: 'Refund sisa saldo campaign expired “Morning Ritual di Nala”',
  },
  {
    id: '2',
    publicId: 'cerita-pedas-mie-bang-jono',
    title: 'Cerita Pedas Mie Bang Jono (Batch 1)',
    campaignStatus: 'ACTIVE',
    brandId: '2',
    brandName: 'Mie Bang Jono',
    ownerEmail: 'miebangjono@plotfy.id',
    endAt: '2026-08-19T00:00:00Z',
    budgetTotal: '5000000.00',
    budgetSpent: '3200000.00',
    unspentLeftover: '1800000.00',
    pendingSubmissionCount: 1,
    pendingValidationCount: 1,
    completedCount: 1,
    totalCreatorCount: 3,
    isPendingCreators: true,
    isRefunded: false,
    refundAmount: '1800000.00',
    refundedAt: null,
    refundDescription: null,
  },
]

export function getDemoExpiredCampaignRefunds() {
  try {
    const raw = localStorage.getItem(DEMO_EXPIRED_REFUNDS_KEY) || sessionStorage.getItem(DEMO_EXPIRED_REFUNDS_KEY)
    if (raw) return JSON.parse(raw)
  } catch {}
  return initialExpiredRefunds
}

export function saveDemoExpiredCampaignRefunds(refunds) {
  try {
    localStorage.setItem(DEMO_EXPIRED_REFUNDS_KEY, JSON.stringify(refunds))
    sessionStorage.setItem(DEMO_EXPIRED_REFUNDS_KEY, JSON.stringify(refunds))
  } catch {}
  window.dispatchEvent(new CustomEvent('plotfy:demo-refunds-changed'))
}

export function forceRefundDemoCampaign(campaignId) {
  const refunds = getDemoExpiredCampaignRefunds()
  const idx = refunds.findIndex((r) => String(r.id) === String(campaignId) || String(r.publicId) === String(campaignId))
  if (idx !== -1) {
    const item = refunds[idx]
    const refundAmt = Number(item.unspentLeftover || item.budgetTotal || 0)
    refunds[idx] = {
      ...item,
      isRefunded: true,
      isPendingCreators: false,
      pendingSubmissionCount: 0,
      pendingValidationCount: 0,
      refundAmount: String(refundAmt.toFixed(2)),
      refundedAt: new Date().toISOString(),
      refundDescription: `Refund langsung Admin: Sisa saldo campaign expired “${item.title || 'Campaign'}”`,
    }
    saveDemoExpiredCampaignRefunds(refunds)
    creditDemoBrandWallet(refundAmt, `Refund langsung Admin campaign expired “${item.title}”`, 'CAMPAIGN_EXPIRED_REFUND')
  }
}

export function getDemoCampaigns() {
  return demoCampaigns
}

export function completeDemoCampaign(campaignId) {
  const apps = getDemoApplications()
  let hasChanges = false
  for (let i = 0; i < apps.length; i++) {
    const app = apps[i]
    if (app.campaignId === campaignId || app.campaign?.id === campaignId || app.campaign?.publicId === campaignId) {
      if (app.status === 'VALIDATED') {
        apps[i] = { ...app, status: 'COMPLETED' }
        hasChanges = true
      }
    }
  }
  if (hasChanges) {
    saveDemoApplications(apps)
  }
}

export function getContactSettings() {
  const s = getDemoSettings()
  return {
    contactEmail: s.contactEmail || 'halo@plotfy.id',
    instagramHandle: s.instagramHandle || 'Instagram',
    instagramUrl: s.instagramUrl || 'https://instagram.com',
    termsUrl: s.termsUrl || 'https://plotfy.id/terms',
  }
}

export function setContactSettings(updates = {}) {
  const current = getDemoSettings()
  if (updates.contactEmail !== undefined) current.contactEmail = String(updates.contactEmail).trim()
  if (updates.instagramHandle !== undefined) current.instagramHandle = String(updates.instagramHandle).trim()
  if (updates.instagramUrl !== undefined) current.instagramUrl = String(updates.instagramUrl).trim()
  if (updates.termsUrl !== undefined) current.termsUrl = String(updates.termsUrl).trim()
  saveDemoSettings(current)
  return getContactSettings()
}

export function getTermsSetting() {
  const s = getDemoSettings()
  return s.termsUrl || 'https://plotfy.id/terms'
}

export function setTermsSetting(url) {
  const current = getDemoSettings()
  current.termsUrl = String(url || '').trim() || 'https://plotfy.id/terms'
  saveDemoSettings(current)
  return current.termsUrl
}







